import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";

import Swal from "sweetalert2";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import UpdateIcon from "@mui/icons-material/Update";
import { ModalDocumentoScresn } from "./ModalDocumentoScresn";
import { LoaderScreen } from "../../components/LoaderScreen";
import SmsIcon from '@mui/icons-material/Sms';
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";


export const ClientesExpedienteDigital = ({ setLoading }) => {
  const { idcliente, clienteselected } = useSelector((store) => store.clientes);
  const [documentos, setDocumentos] = useState([]);
  const [state, setState] = useState({
    idclientedocumento: -1,
    documento: "",
    iddocumento: -1,
    orden: -1,
    comentarios: "",
  });
  const openModal = (idclientedocumento, documento, iddocumento, orden) => {
    var modal = document.getElementById("modal-documentos");
    modal.style.display = "block";
    setState({
      idclientedocumento,
      documento,
      iddocumento,
      orden,
    });
  };

  // const openModal2 = (idclientedocumento, documento, iddocumento, orden, comentarios) => {
  //   var modal = document.getElementById("modal-documentos");
  //   modal.style.display = "block";
  //   setState({
  //     idclientedocumento,
  //     documento,
  //     iddocumento,
  //     orden,
  //     comentarios
  //   });
  // };
  const [openComentarios, setOpenComentarios] = useState(false);

  const handleOpenComentarios = () => {
    setOpenComentarios(true);
  };

  const handleCloseComentarios = () => {
    setOpenComentarios(false);
  };

  const [buttonselect, setButtonSelect] = useState("M");
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const modalContent = (idclientedocumento) => {

    return (
      <div className="modal-comentarios-container">
        <div></div>
        <div>hola</div>
      </div>
    );
  };

  useEffect(() => {
    if (
      idcliente === undefined ||
      idcliente === null ||
      idcliente === 0 ||
      idcliente === "0" ||
      idcliente === "" ||
      idcliente === "-1" ||
      idcliente === "-1"
    )
      return;
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ClienteDocumentacion/Listado?idcliente=${idcliente}&financiera=${buttonselect}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDocumentos(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  }, [idcliente, buttonselect]);
  const onDescargar = (idclientedocumento) => {
    request
      .get(
        `ClienteDocumentacion/BuscarID?idclientedocumento=${idclientedocumento}`
      )
      .then((result) => {
        const linkSource = result.documento;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombre}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  if (
    idcliente === undefined ||
    idcliente === null ||
    idcliente === 0 ||
    idcliente === "0" ||
    idcliente === "" ||
    idcliente === "-1" ||
    idcliente === "-1"
  ) {
    return <div>Favor de seleccionar un cliente</div>;
  }
  const capitalizeWords = (str) => {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <div className="cliente-expediente-digital">
      <LoaderScreen loader={loader} />
      <ModalDocumentoScresn
        idclientedocumento={state.idclientedocumento}
        documento={state.documento}
        orden={state.orden}
        iddocumento={state.iddocumento}
        idcliente={idcliente}
        setDocumentos={setDocumentos}
      />
      <div className="cliente-expediente-digital-header">
        <div className="cliente-expediente-digital-header-titulo">
          {capitalizeWords(clienteselected)}
        </div>
        <div
          className={`cliente-expediente-digital-header-btn ${buttonselect === "M"
            ? "cliente-expediente-digital-header-btn-selected"
            : ""
            }`}
          onClick={() => setButtonSelect("M")}
        >
          MHUSA
        </div>
        <div
          className={`cliente-expediente-digital-header-btn ${buttonselect === "J"
            ? "cliente-expediente-digital-header-btn-selected"
            : ""
            }`}
          onClick={() => setButtonSelect("J")}
        >
          JDF
        </div>
      </div>
      <div className="cliente-expediente-digital-container scroll-4">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>Num</th>
              <th>Documento</th>
              <th></th>
              <th>Vigencia</th>
              <th>Estado</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {documentos.map((item) => (
              <tr>
                <td>{item.iddocumento}</td>
                <td>{capitalizeWords(item.documento)}</td>
                <td onClick={() => {
                  Swal.fire({
                    title: 'DOCUMENTACION',
                    icon: 'info',
                    text: item.comentarios
                  })
                }}>
                  <SmsIcon />
                  {/* <SmsIcon onClick={() => handleOpenComentarios(item.comentarios)}  /> */}
                  {/* {item.comentarios} */}
                  {/* <Modal open={openComentarios} onClose={handleCloseComentarios} >
                    {modalContent()}
                  </Modal> */}
                </td>
                <td>{item.vigencia}</td>
                <td>
                  <div
                    className={`${item.estado >= 1
                      ? "div-vencido"
                      : item.estado <= 0 && item.estado >= -30
                        ? "div-porvencer "
                        : ""
                      }`}
                  >
                    {item.vigencia === "-"
                      ? "-"
                      : item.estado >= 1
                        ? "Vencido"
                        : item.estado <= 0 && item.estado >= -30
                          ? "Por vencer"
                          : "Vigente"}
                  </div>
                </td>
                <td className="actions">
                  <div
                    className="update button-table"
                    onClick={() =>
                      openModal(
                        item.idclientedocumento,
                        item.documento,
                        item.iddocumento,
                        item.orden
                      )
                    }
                  >
                    <UpdateIcon />
                    Actualizar
                  </div>
                  {item.idclientedocumento > 0 ? (
                    <div
                      className="download button-table"
                      onClick={() => onDescargar(item.idclientedocumento)}
                    >
                      <CloudDownloadIcon /> Descargar
                    </div>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
